import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";
import { makeOfflineRequest } from "../../shared/utils.js/offlineRequestManager";

// Get work shifts
export const getWorkShifts = createAsyncThunk(
  "WorkShifts/getWorkShifts",
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search) queryParams.append("search", params.search);
      const url = `/work-shifts${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await makeOfflineRequest(url, "GET");
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to get work shifts!";
      return rejectWithValue(message);
    }
  },
);

// add work shift
export const addWorkShift = createAsyncThunk(
  "WorkShifts/addWorkShift",
  async (shiftData, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.post(`${BASE_URL}/work-shifts`, shiftData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });

      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to add work shift!";
      return rejectWithValue(message);
    }
  },
);

// update work shift
export const updateWorkShift = createAsyncThunk(
  "WorkShifts/updateWorkShift",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.put(`${BASE_URL}/work-shifts/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });

      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to update work shift!";
      return rejectWithValue(message);
    }
  },
);

// delete work shift
export const deleteWorkShift = createAsyncThunk(
  "WorkShifts/deleteWorkShift",
  async (shiftId, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.delete(
        `${BASE_URL}/work-shifts/${shiftId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );

      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to delete work shift!";
      return rejectWithValue(message);
    }
  },
);

// get work shift details
export const getWorkShiftDetails = createAsyncThunk(
  "WorkShifts/getWorkShiftDetails",
  async (shiftId, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.get(`${BASE_URL}/work-shifts/${shiftId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });

      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get work shift details!";
      return rejectWithValue(message);
    }
  },
);
